<template>
  <v-dialog
    v-model="showingDeleteUserModal"
    width="auto"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{$t('¿Estás seguro de eliminar el usuario')}} '{{ user.name }}'?
      </v-card-title>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn 
          color="tertiary" 
          outlined 
          @click="close()"
        >
          {{$t('Cancelar')}}
        </v-btn>         
        <v-btn
          color="error"
          outlined
          @click="deleteUser()"
        >
          {{$t('Eliminar')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data: () => {
    return {
      showingDeleteUserModal: false,
      user: {}
    }
  },

  methods: {
    openModal(user) {
      this.showingDeleteUserModal = true
      this.user = user
    },

    close() {
      this.showingDeleteUserModal = false
    },

    async deleteUser() {
      try {
        const response = await this.$api.deleteUser(this.user.id)

        this.$emit('reload-user-list')
        this.close()
      } catch(e) {
        console.log(e)
      }
    }
  }
}
</script>